import {createFileRoute} from '@tanstack/react-router';

import {categoryKeys} from '@/features/Library/api/queryKeys';
import {getCategory} from '@/features/Library/api/readCategory';
import {UpdateCategoryForm} from '@/features/Library/components/Category/UpdateCategoryForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/categories/update/$categoryId'
)({
  component: UpdateCategoryForm,
  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.categoryId}`);

    return {
      ...context,
      readCategoryQuery: {
        queryKey: categoryKeys.detail(params.categoryId),
        queryFn: () => getCategory(params.categoryId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readCategoryQuery);
  },
});
